import React from 'react';
import { motion } from 'framer-motion';
import { Database, Cloud, Globe, Server, Box, Terminal, Wifi, Lock } from 'lucide-react';

const Integrations = () => {
    const integrations = [
        { icon: <Database />, name: "DataNexus", category: "Database" },
        { icon: <Cloud />, name: "SkyNet Cloud", category: "Infrastructure" },
        { icon: <Globe />, name: "GlobalConnect", category: "Network" },
        { icon: <Server />, name: "CoreServer", category: "Backend" },
        { icon: <Box />, name: "ContainerBox", category: "DevOps" },
        { icon: <Terminal />, name: "CommandShell", category: "Utility" },
        { icon: <Wifi />, name: "SignalStream", category: "IoT" },
        { icon: <Lock />, name: "SecureVault", category: "Security" },
    ];

    return (
        <div className="min-h-screen bg-cyber-gray text-white font-rajdhani relative overflow-hidden">
            {/* Background Grid Animation */}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 relative z-10">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <span className="text-neon-purple font-mono tracking-widest text-sm uppercase mb-4 block">Ecosystem Connectivity</span>
                    <h1 className="text-5xl md:text-7xl font-bold font-orbitron bg-clip-text text-transparent bg-gradient-to-r from-neon-purple via-white to-neon-blue mb-6">
                        INTEGRATIONS
                    </h1>
                    <p className="text-xl text-gray-400 max-w-2xl mx-auto">
                        Seamlessly link your pipeline with the most powerful tools in the digital multiverse.
                    </p>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {integrations.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            whileHover={{ scale: 1.05, borderColor: '#a855f7' }}
                            className="bg-gray-900/40 backdrop-blur-sm border border-gray-800 p-6 rounded-lg flex flex-col items-center justify-center gap-4 hover:shadow-[0_0_20px_rgba(168,85,247,0.3)] transition-all duration-300"
                        >
                            <div className="text-neon-purple w-12 h-12 flex items-center justify-center bg-gray-800 rounded-full">
                                {item.icon}
                            </div>
                            <div className="text-center">
                                <h3 className="text-lg font-bold text-white font-orbitron">{item.name}</h3>
                                <p className="text-xs text-gray-500 uppercase tracking-wider mt-1">{item.category}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Integrations;
